/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-23 20:23:54 */

const Keys = {
  titleExpired: 'titleExpired',
  titleIsAboutToExpire: 'titleIsAboutToExpire',
  sessionExpiredText: 'sessionExpiredText',
  sessionIsAboutToExpire: 'sessionIsAboutToExpire',
  buttonExpired: 'buttonExpired',
  buttonRefresh: 'buttonRefresh',
  close: 'close'
}; export default Keys;